import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { RESET_GAME_SESSION_COMMAND, USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { namespace } from 'vuex-class';
import { GAME_SESSION_NAMESPACE } from '../../store/modules/game-session/game-session.constants.js';
import '../../store/modules/game-session/game-session.store.js';
import { store } from '../../store/index.js';

var gameSessionModule = namespace(GAME_SESSION_NAMESPACE);
var SessionSummaryManagerComponent = /** @class */ (function (_super) {
    __extends(SessionSummaryManagerComponent, _super);
    function SessionSummaryManagerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subscriptions = [];
        _this.currentJurisdiction = null;
        _this.resetGameSessionSummarySubscription = null;
        return _this;
    }
    SessionSummaryManagerComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 1:
                        _a.currentJurisdiction = _b.sent();
                        if (this.currentJurisdiction === Jurisdiction.LOTBA ||
                            this.currentJurisdiction === Jurisdiction.AGCO ||
                            this.currentJurisdiction === Jurisdiction.EMTA) {
                            this.getGameSessionSummary();
                        }
                        this.subscriptions.push(magic.events.gameSessionSummary(function (payload) {
                            _this.setGameSessionSummary(payload);
                        }).unsub);
                        this.resetGameSessionSummarySubscription = window.commandBus.subscribe(RESET_GAME_SESSION_COMMAND, function () {
                            _this.resetGameSessionSummary();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    SessionSummaryManagerComponent.prototype.getGameSessionSummary = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchGameSessionSummary()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SessionSummaryManagerComponent.prototype.render = function () {
        return null;
    };
    SessionSummaryManagerComponent.prototype.destroyed = function () {
        var _a;
        this.subscriptions.forEach(function (unsub) { return unsub(); });
        (_a = this.resetGameSessionSummarySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    __decorate([
        gameSessionModule.Action('fetchGameSessionSummary'),
        __metadata("design:type", Object)
    ], SessionSummaryManagerComponent.prototype, "fetchGameSessionSummary", void 0);
    __decorate([
        gameSessionModule.Action('resetGameSessionSummary'),
        __metadata("design:type", Object)
    ], SessionSummaryManagerComponent.prototype, "resetGameSessionSummary", void 0);
    __decorate([
        gameSessionModule.Action('setGameSessionSummary'),
        __metadata("design:type", Object)
    ], SessionSummaryManagerComponent.prototype, "setGameSessionSummary", void 0);
    __decorate([
        gameSessionModule.Getter('betsPlaced'),
        __metadata("design:type", void 0)
    ], SessionSummaryManagerComponent.prototype, "betsPlaced", void 0);
    __decorate([
        gameSessionModule.Getter('betWins'),
        __metadata("design:type", void 0)
    ], SessionSummaryManagerComponent.prototype, "betWins", void 0);
    SessionSummaryManagerComponent = __decorate([
        Component({
            name: 'session-summary-manager',
            store: store,
        })
    ], SessionSummaryManagerComponent);
    return SessionSummaryManagerComponent;
}(Mixins(MagicConfigMixin)));

export { SessionSummaryManagerComponent };
